// extracted by mini-css-extract-plugin
module.exports = {"container":"common_container__3tVNB","table":"common_table__24M5Z","period":"common_period__2Rw_c","status":"common_status__2Bw9X","statusActive":"common_statusActive__2PgbE"};